module.exports = __webpack_public_path__ + "img/9788954438445.fdaf49a7.jpg";